import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FuelSelectorPage } from './fuel-selector.page';

const routes: Routes = [
  {
    path: '',
    component: FuelSelectorPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FuelSelectorPageRoutingModule {}
